import { Base } from '@studiometa/js-toolkit';
import mapboxgl from 'mapbox-gl';

/**
 * Store class for store page.
 */
export default class Store extends Base {
  static config = {
    name: 'Store',
    options: {
      lat: {
        type: String,
        default: '',
      },
      lng: {
        type: Number,
        default: '',
      },
    },
  };

  /**
   * Mounted
   */
  mounted() {
    this.lat = Number.parseFloat(this.$options.lat);
    this.lng = Number.parseFloat(this.$options.lng);

    document.querySelector(`[data-day="${this.day}"]`).style.fontWeight = '700';

    mapboxgl.accessToken =
      'pk.eyJ1IjoiYWdlbmNlc3R1ZGlvbWV0YSIsImEiOiJjbHZwOHc2c2cwMWk3MnFwYXRzMnV3MnkyIn0.II7sfCx6_qDd01mOMc26Eg';
    const map = new mapboxgl.Map({
      container: 'map', // container ID
      style: 'mapbox://styles/agencestudiometa/clach5esa000f16mvk20hh48o', // style URL
      center: [this.lng, this.lat],
      zoom: 15,
    });

    // eslint-disable-next-line no-unused-vars
    const marker1 = new mapboxgl.Marker().setLngLat([this.lng, this.lat]).addTo(map);
  }

  get day() {
    const d = new Date();
    return d.getDay();
  }
}
